<template lang="pug">
#modal-reanalise-certificacao
    el-dialog(
        title='Solicitação de Laudo',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        p
            b Deseja realmente solicitar laudo para os dados abaixo?
        hr
        p
            b Território:
            |
            | {{ rowInfo.geometrias[0].nomeTerritorio }}
        p
            b Localidade:
            |
            | {{ rowInfo.geometrias[0].municipioTerritorioNome }} / {{ rowInfo.geometrias[0].estadoTerritorioSigla }}
        p.margin-p
            b CAR(s) vinculado(s):
            ul.lista-car
                li.lista(v-for='car in rowInfo.cars')
                    span {{ car.codigo }}

        .d-flex.flex-direction.justify-content-between.py-3
            el-button(slot='footer', size='mini', @click='closeDialog') Voltar
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                @click='solicitarLaudo'
            ) Continuar
</template>

<script>
import BlocoListarAtivasCertificao from '@/components/certificacao/BlocoListarAtivasCertificao.vue';
import CertificacaoService from '@/services/CertificacaoService';
export default {
    name: 'ModalSolicitarLaudo',
    components: {
        BlocoListarAtivasCertificao
    },
    emits: ['update:show'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: []
            }
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.certificacao.idsCertificacaoTipo = idsCertificacaoTipo.idsTipo;
        },
        clearFields() {
            this.certificacao.idsTerritorio = [];
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        async solicitarLaudo() {
            if (!this.rowInfo.geometrias.length) {
                this.$notify.error({
                    message:
                        'Necessário inserir ao menos um território para realizar análise.'
                });
                return;
            }

            try {
                await CertificacaoService.solicitarLaudo(this.rowInfo.id);
                this.$notify.success({
                    message: 'Solicitação de laudo realizado com sucesso!'
                });
                this.atualizarTabela();
                this.closeDialog();
            } catch (error) {
                this.$notify.error({
                    message: 'Erro na requisição de solicitacao de laudo.'
                });
                this.clearFields();
            }
        }
    }
};
</script>

<style lang="scss">
.el-dialog__header {
    padding: 20px;
    padding-bottom: 10px;
    background: #f6f6f6;
    color: #3b3b3b;
    padding-bottom: 12px;
    padding-top: 12px;
}
.el-dialog__body {
    padding: 20px 20px 30px 20px;
    word-break: break-word;
}
.el-dialog__headerbtn {
    top: 10px;
}
.el-dialog__headerbtn:hover .el-icon-close {
    color: #ffffff;
}

.el-dialog__title {
    color: var(--primary);
    font-weight: bold;
}
</style>
